import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from "../../helpers/i18n";
import { getItemOfSessionStorage } from '../../services/common/utils';
import Loadingcomponent from '../../components/loader/loadingcomponent';
import { SELECTED_LANG } from '../../services/common/Constants';
import { GTMScreenView } from "../../../src/analytics/GoogleTagManager";
import { useSelector, useDispatch } from "react-redux";
import HeaderComponent from '../../components/header';
import { setPaciLogin, setCivilID } from '../../reducer/utilitySlice';
import {CT_Events} from "../../../src/analytics/CTEvents";
const PaciCivilID = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    utilityData: { globalSetting, isPaciLogin },
  } = useSelector((state) => state);
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const logintype = useSelector((state) => state ?.userdata ?.value ?.loginmode);
  const msisdn = useSelector((state) => state ?.userdata ?.value ?.selectedmsisdn);
  const [civilAddress, setCivilAddress] = useState('');
  const [error, setError] = useState('');
  const [continueDisabled, setContinueDisabled] = useState(true);
  const {CT_ScreenView} = CT_Events();

  useEffect(() => {
    i18n.changeLanguage(lang)
  }, [lang])

  useEffect(() => {
    try {
      GTMScreenView("paci-civilid", msisdn, logintype);
    } catch{ }
    try{
      CT_ScreenView()
    }catch{}
  }, [])


  const valUserCivilID = () => {
    if (civilAddress.length === 0) {
      setError(t("tfr"))//t('tfr')
    }
     else if (civilAddress.length === 12) {
      dispatch(setPaciLogin(true))
      dispatch(setCivilID(civilAddress));
    } else {
      setError(t("pevcid"));// t('')
    }
  };


  const validateTextInput = value => {
    let validStr = value;
    if (validStr) {
      let validText = validStr.replace(
        /[`\D~!@#$%^&*()_|+\-=?;•√π÷×¶∆£¢€¥°©®™✓:'",.<> \{\}\[\]\\\/]/g,
        ''
      );
      validStr = validText.replace('‘', '');
      validStr = validText.replace('“', '');
      if (validStr) {
        if (!value.trim()) {
          setError(t('pemn'));
          return;
        } 
        else {
          if(value.length < 12){
            setContinueDisabled(true)
          }
          else if(value.length === 12){
            setContinueDisabled(false);
          }
          else if(value.length > 12){
            return;
          }
          setError('');
        }
      }
    }
    setCivilAddress(validStr);
  };


  return (
    <div>
      <HeaderComponent type={1}></HeaderComponent>
      <section className="app_main_wrapper d-flex flex-column">
        <div className="pse_lg mt-100" style={{ marginTop: "84px" }}>
          <h3 className="section_title_light mb-4">{t('entercivilidnumber')}</h3>
          <div className="mb-4">
            <input
              pattern="\\d*"
              className="form-control"
              placeholder=""
              max={12}
              value={civilAddress}
              onChange={val =>
                validateTextInput(val.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<> \{\}\[\]\\\/]/g, ''))
              }
            />

            {error &&
              <p className="text-danger">
                {error ? error : ""}
              </p>
            }
          </div>
          <button
            className= {isPaciLogin ? "custom_btn custom_btn_secondry btn_block": "custom_btn custom_btn_primary btn_block "  }
            disabled={continueDisabled}
            onClick={valUserCivilID}
          >
            {isPaciLogin ? <Loadingcomponent/> : t('continue')}
          </button>        
        </div>
      </section>
    </div>
  );
};
export default PaciCivilID;
